module.exports = __webpack_public_path__ + "img/hr-underground-belt-structure.0751e27f.png";